/* eslint-disable no-nested-ternary */
import React from "react";
import { DEFAULT_PROFILE_PIC_SRC } from "repoV2/utils/common/assets/assets";
import { SECTION_IDS } from "@Utils";
import { ITemplate } from "@Templates/ITemplate";
import styles from "../HostInfoPanel/hostInfoPanel.module.scss";

// TODO - @aditya: use it in HostInfoPanel in phase2
const AboutCover = ({
    coverImg,
    profileImg,
    preview,
}: ITemplate.IAboutSectionProps): JSX.Element => {
    const defaultProfilePic = DEFAULT_PROFILE_PIC_SRC;
    const defaultCoverPic = "/static/images/cover_background.png";

    return (
        <section>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a id={SECTION_IDS.about} />
            <div className={styles.container}>
                <div className={styles.images}>
                    {coverImg ? (
                        <img
                            src={coverImg}
                            alt="cover"
                            loading="lazy"
                            className={styles.coverImage}
                        />
                    ) : preview ? (
                        <h1
                            className={styles.coverImage}
                            style={{
                                backgroundColor: "#f2f2f4",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#555",
                                textAlign: "center",
                            }}
                        >
                            {"< Your cover image will be displayed here >"}
                        </h1>
                    ) : (
                        <img
                            src={defaultCoverPic}
                            alt="cover"
                            loading="lazy"
                            className={styles.coverImage}
                        />
                    )}
                    {profileImg ? (
                        <img
                            src={profileImg}
                            alt="profile_pic"
                            loading="lazy"
                            className={styles.profilePic}
                        />
                    ) : preview ? (
                        <div
                            className={styles.profilePic}
                            style={{
                                backgroundColor: "#f2f2f4",
                                width: 180,
                                height: 180,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                color: "#555",
                                opacity: 0.9,
                            }}
                        >
                            {"< Your profile pic will be displayed here >"}
                        </div>
                    ) : (
                        <img
                            src={defaultProfilePic}
                            alt="profile_pic"
                            loading="lazy"
                            className={styles.profilePic}
                        />
                    )}
                </div>
            </div>
        </section>
    );
};

export default AboutCover;
